import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

export default function ApprovedVendors() {
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchApprovedVendors();
  }, []);

  const fetchApprovedVendors = async () => {
    setLoading(true);
    try {
      const response = await axios.get("/api/services?status=approved&type=vendor");
      setVendors(response.data);
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch approved vendors.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: "1200px", margin: "50px auto", padding: "20px" }}>
      <h2>Approved Vendors</h2>

      {loading ? (
        <p>Loading approved vendors...</p>
      ) : vendors.length === 0 ? (
        <p>No approved vendors available at the moment.</p>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: "20px" }}>
          {vendors.map((vendor) => (
            <div key={vendor._id} style={{ border: "1px solid #ddd", borderRadius: "8px", padding: "15px", backgroundColor: "#f9f9f9" }}>
              {vendor.images && vendor.images.length > 0 && (
                <img src={vendor.images[0]} alt={vendor.name} style={{ width: "100%", borderRadius: "5px", marginBottom: "10px" }} />
              )}
              <h3>{vendor.name}</h3>
              <p><strong>Location:</strong> {vendor.location}</p>
              <p><strong>Business Address:</strong> {vendor.address}</p>
              <p><strong>Description:</strong> {vendor.description}</p>
              <p><strong>Phone:</strong> {vendor.phone}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
